import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import FiscContratosService from '../../../../../services/fiscContratos-auth';
import Fiscal from './fiscal';


const ListarFiscal = () => {

    const [fiscais, setFiscais] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [secs, setSecs] = useState([]);
    const [fiscal, setFisc] = useState("");


    async function fetchFiscais() {
        await montaSelectLocais()
        const response = await FiscContratosService.listar();
        if (response.data.length >= 1) {
            setFiscais(response.data)
            setVazio(false)
        } else {
            setFiscais([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setFisc(id);
        setEditar(true)
    }

    const montaSelectLocais = async () => {
        let prod = await FiscContratosService.listar();
        const uniqueSecs = [...new Map(prod.data.map(item => [item['secretaria'], item])).values()];
        setSecs(uniqueSecs)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Fiscal?')) {
            await FiscContratosService.deletar(id)
            alert("Fiscal deletado com sucesso!")
            fetchFiscais();
        }
    }

    useEffect(() => {
        fetchFiscais();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/contratos/fiscais/editar/${fiscal}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setFiscais={setFiscais}
                        setVazio={setVazio}
                        secs={secs}
                        fetchFiscais={fetchFiscais}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={3}>
                            {fiscais.map((fiscal, index) =>
                                <Fiscal
                                    fetchFiscais={fetchFiscais}
                                    fiscal={fiscal}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarFiscal;